module.exports = __webpack_public_path__ + "static/media/mailnews_14.c5bfb3b6.ico";